var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumQuanlityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D08E03"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 10.1533L14.9531 10.58L12.8131 7.9133C12.7161 7.80167 12.5963 7.71216 12.4617 7.65082C12.3272 7.58948 12.181 7.55774 12.0331 7.55774C11.8853 7.55774 11.7391 7.58948 11.6045 7.65082C11.47 7.71216 11.3501 7.80167 11.2531 7.9133L9.11314 10.58L7.36647 10.1533C7.19908 10.1132 7.02421 10.1168 6.85857 10.1635C6.69292 10.2103 6.54204 10.2988 6.42033 10.4205C6.29863 10.5422 6.21016 10.6931 6.16338 10.8587C6.1166 11.0244 6.11307 11.1992 6.15314 11.3666L7.29314 15.9066C7.34554 16.1235 7.46938 16.3163 7.64474 16.4542C7.82009 16.5921 8.03675 16.6669 8.25981 16.6666H15.7398C15.9629 16.6669 16.1795 16.5921 16.3549 16.4542C16.5302 16.3163 16.6541 16.1235 16.7065 15.9066L17.8465 11.3666C17.8844 11.2026 17.8805 11.0316 17.8352 10.8694C17.7899 10.7072 17.7047 10.559 17.5873 10.4382C17.4699 10.3175 17.3241 10.2282 17.1632 10.1784C17.0023 10.1286 16.8315 10.12 16.6665 10.1533Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 9.66667C6.29357 9.66667 6.66667 9.29357 6.66667 8.83333C6.66667 8.3731 6.29357 8 5.83333 8C5.3731 8 5 8.3731 5 8.83333C5 9.29357 5.3731 9.66667 5.83333 9.66667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1668 9.66667C18.6271 9.66667 19.0002 9.29357 19.0002 8.83333C19.0002 8.3731 18.6271 8 18.1668 8C17.7066 8 17.3335 8.3731 17.3335 8.83333C17.3335 9.29357 17.7066 9.66667 18.1668 9.66667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.83329C12.4601 6.83329 12.8332 6.4602 12.8332 5.99996C12.8332 5.53972 12.4601 5.16663 11.9998 5.16663C11.5396 5.16663 11.1665 5.53972 11.1665 5.99996C11.1665 6.4602 11.5396 6.83329 11.9998 6.83329Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 18.6666H8.00016C7.82335 18.6666 7.65378 18.5963 7.52876 18.4713C7.40373 18.3463 7.3335 18.1767 7.3335 17.9999C7.3335 17.8231 7.40373 17.6535 7.52876 17.5285C7.65378 17.4035 7.82335 17.3333 8.00016 17.3333H16.0002C16.177 17.3333 16.3465 17.4035 16.4716 17.5285C16.5966 17.6535 16.6668 17.8231 16.6668 17.9999C16.6668 18.1767 16.5966 18.3463 16.4716 18.4713C16.3465 18.5963 16.177 18.6666 16.0002 18.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumQuanlityIcon);
export default __webpack_public_path__ + "static/media/premium-quanlity-icon.bdcb6c819fa88cae1fe13855aa209e68.svg";
export { ForwardRef as ReactComponent };